import { ChatMap, } from "openchat-shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class ChatSummaryUpdates {
    notificationsMuted;
    archived;
    rulesAccepted;
    latestMessage;
    frozen;
    name;
    description;
    permissions;
    gateConfig;
    eventsTTL;
    isPublic;
}
export const chatSummaryLocalUpdates = writable(new ChatMap(), undefined, notEq);
